var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],attrs:{"title":_vm.title}},[_c('InformationOutline',{staticClass:"tooltip-color",attrs:{"size":20,"fillColor":_vm.fillColor}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }